export enum PayMonthStatusEnum {
  NoActiveEmployments = 'NO_ACTIVE_EMPLOYMENTS',
  ReportingNotDone = 'REPORTING_NOT_DONE',
  ReportingDelayed = 'REPORTING_DELAYED',
  ReportingApproved = 'REPORTING_APPROVED',
  ReportWithDeviations = 'REPORT_WITH_DEVIATIONS',
  ReportProcessing = 'REPORT_PROCESSING',
}
